module.exports = {
  title: 'BOLD Summer Festival',
  description: 'Summer. Party. Music. Good people. Fun.',
  debugMode: false,
  // be sure to not add any / at the end of URL
  url: {
    dev: 'http://localhost:3333',
    prod: 'https://bold-summer-festival.vercel.app/'
  },
  api: {
    projectId: '5lngsflx',
    dataset: 'production',
    // dataset: process.env.NODE_ENV === 'production' ? 'production' : 'develop',
    // Add current date to fix the data api version. This avoids breaking changes over the time.
    apiVersion: '2021-10-11',
    useCdn: true
  },
  modules: {
    // TODO: Webfontloader: https://github.com/Developmint/nuxt-webfontloader
    googleTagManager: {
      active: false,
      id: 'GTM-XXXXXXX'
    },
    googleAnalytics: {
      active: false,
      id: 'UA-XXXXXX-X'
    },
    sendgrid: {
      active: true,
      id: process.env.SENDGRID_ID
    },
    cookieConsent: {
      active: true,
      position: 'br', // tl = topleft, tr = topright, bl = bottomleft, br = bottomright
      transition: 'fb' // fd = fade, ft = fromTop, fl = fromLeft, fb = fromBottom, fr = fromRight
    }
  },
  mixins: {
    setDevmode: true,
    setViewportSizes: false
  },
  i18n: {
    baseUrl:
      process.env.NODE_ENV === 'production'
        ? 'https://bold-summer-festival.vercel.app/'
        : 'http://localhost:3333/',
    strategy: 'prefix_except_default',
    langDir: '~/locales/',
    vuex: {
      moduleName: 'i18n',
      syncRouteParams: true
    },
    locales: [
      {
        code: 'en',
        iso: 'en',
        file: 'en.json'
      },
      {
        code: 'de',
        iso: 'de',
        file: 'de.json'
      }
    ],
    defaultLocale: 'de',
    detectBrowserLanguage: {
      useCookie: true,
      cookieKey: 'i18n_redirected',
      fallbackLocale: 'de',
      redirectOn: 'root'
    }
  }
};
